/* Provencelia, 14/10/2026 : filtres des collections (chargé par sections/main-collection).
   1. Volume en tranches (snippets/pv-filtre-volume) : cocher une tranche active les champs cachés de ses litres,
      décocher les désactive. Écouté en phase de capture, donc AVANT que le thème lise le formulaire.
   2. Panneau de filtres mobile : le bouton « Appliquer » devient « Voir 42 produits », recalculé à chaque case
      cochée, via la petite section sections/pv-compte-filtres (le nombre seul, pas toute la grille).
   3. Barre des filtres les plus utilisés (snippets/pv-raccourcis-filtres) : un appui sur « Couleur », « Prix »...
      ouvre le panneau de filtres directement sur ce filtre, déplié. */
(function () {
  'use strict';
  if (window.pvFiltresCharge) return; // chargé par sections/main-collection et snippets/facets : une seule fois
  window.pvFiltresCharge = true;

  document.addEventListener('change', function (e) {
    var caseTranche = e.target;
    if (!caseTranche || !caseTranche.matches || !caseTranche.matches('[data-pv-tranche]')) return;
    var bloc = caseTranche.closest('.checkbox-control');
    if (!bloc) return;
    bloc.querySelectorAll('[data-pv-tranche-champ]').forEach(function (champ) {
      champ.disabled = !caseTranche.checked;
    });
  }, true);

  function boutonVoir() {
    var pied = document.querySelector('#facets-drawer [data-pv-voir]');
    if (!pied) return null;
    var bouton = pied.querySelector('button');
    if (!bouton) return null;
    if (!bouton.hasAttribute('data-pv-libelle')) bouton.setAttribute('data-pv-libelle', bouton.textContent.trim());
    return { bouton: bouton, voir: pied.getAttribute('data-pv-voir') };
  }

  function afficher(texteNombre) {
    var b = boutonVoir();
    if (!b) return;
    var cible = b.bouton.querySelector('span') || b.bouton;
    cible.textContent = texteNombre ? b.voir + ' ' + texteNombre : b.bouton.getAttribute('data-pv-libelle');
  }

  function nombreActuel() {
    var n = document.querySelector('.collection-toolbar__products-count');
    return n ? n.textContent.trim() : '';
  }

  var minuteur = null;
  var demande = 0;

  function recompter(facetsForm) {
    var form = facetsForm.querySelector('form');
    if (!form) return;
    var params = new URLSearchParams(new FormData(form));
    ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach(function (cle) {
      if (params.get(cle) === '') params.delete(cle);
    });
    params.set('section_id', 'pv-compte-filtres');
    // Aperçu d'un thème non publié : la section n'existe que sur ce thème. NB : avec preview_theme_id, Shopify ne
    // garde que la dernière valeur d'un filtre numérique (volume) ; le nombre affiché en aperçu peut donc être
    // faux pour une tranche de volume. Sur le thème publié (sans ce paramètre), il est juste.
    if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') params.set('preview_theme_id', Shopify.theme.id);
    var url = new URL(form.action);
    url.search = params.toString();
    var numero = ++demande;
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (numero !== demande) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var n = doc.querySelector('[data-pv-compte]');
        afficher(n ? n.textContent.trim() : '');
      })
      .catch(function () { if (numero === demande) afficher(''); });
  }

  document.addEventListener('change', function (e) {
    var facetsForm = e.target && e.target.closest && e.target.closest('#facets-drawer facets-form');
    if (!facetsForm) return;
    clearTimeout(minuteur);
    minuteur = setTimeout(function () { recompter(facetsForm); }, 250);
  });

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[aria-controls="facets-drawer"]')) afficher(nombreActuel());
  });

  document.addEventListener('click', function (e) {
    var bouton = e.target && e.target.closest && e.target.closest('[data-pv-ouvrir]');
    if (!bouton) return;
    var tiroir = document.getElementById('facets-drawer');
    if (!tiroir) return;
    var param = bouton.getAttribute('data-pv-ouvrir');
    var champ = tiroir.querySelector('input[name^="' + param + '"]');
    var bloc = champ && champ.closest('accordion-disclosure');
    var details = bloc && bloc.querySelector('details');
    if (details && !details.open) {
      var resume = details.querySelector('summary');
      if (resume) resume.click(); else details.open = true;
    }
    afficher(nombreActuel());
    if (typeof tiroir.show === 'function') tiroir.show();
    else { var ouvrir = document.querySelector('[aria-controls="facets-drawer"]'); if (ouvrir) ouvrir.click(); }
    if (bloc) setTimeout(function () { bloc.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 350);
  });

  // Couleurs : « Voir les N autres » déplie les couleurs moins fournies (snippets/facets)
  document.addEventListener('click', function (e) {
    var bouton = e.target && e.target.closest && e.target.closest('[data-pv-plus]');
    if (!bouton) return;
    var reste = bouton.previousElementSibling;
    if (reste && reste.classList.contains('pv-plus')) reste.hidden = false;
    bouton.remove();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { afficher(nombreActuel()); });
  } else {
    afficher(nombreActuel());
  }
})();
